const megaMenuData = {
  "Explore by Goal": [
    "Learn AI",
    "Launch a new career",
    "Prepare for a certification",
    "Practice with Role Play"
  ],

   Schools: [
    "Web Development",
    "Coding and App Development",
    "Web Gadget Collecting using JavaScript and API",
    "Web App Development with HTML5 and JavaScript",
    "Web App Development with HTML5 and CSS Animation",
    "AR VR",
    "Python for Kids",
    "Android App Development using AI in MIT",
    "Space Science Course",
    "Tkinter Python GUI",
    "Sugarlabs Turtle"
  ],

  Colleges: [
    "Web Development",
    "Web App Development with HTML5 and JavaScript",
    "Full Stack Web Application Using Firebase ",
    "Web 3.0 Development with Blockchain and NFTs",
    "Game Development",
    "AR VR",
    "Python",
    "Java",
    "C programming",
    "C++ programming",
    "Data Structures & Algorithms",
    "PHP/MYSQL",
    "Machine Learning",
    "Deep Learning",
    "Data Science",
    "Angular",
    "React",
    "Node.js",
    "Power BI",
    "UI/UX",
    "MERN Stack Development",
    "Mastering Excel essentials-Fundamentals to Foundational Skill",
    "Web Scrapping with Python and Beautiful soup"
  ],

  Corporates:[
 "Microsoft using AI",
    "English Communication",
    "Upskilling for Experienced Employee",
    "It training for Fresher",
  ]
};

export default megaMenuData;
